export function displayPrice(price: number|string, zeroValue: any = null): string|any {
    price = Number(price)
    if (price === 0 && zeroValue !== null){
        // To be able to return a translation if the price is 0.
        return zeroValue
    }

    return (price / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
}

export function discountPercentage(productPrice: number|string, productOriginalPrice: number|string): number {
    var price = 0
    var originalPrice = 0

    if (typeof productPrice === 'string'){
      price = parseInt(productPrice, 10)
    } else {
      price = productPrice
    }

    if (typeof productOriginalPrice === 'string'){
      originalPrice = parseInt(productOriginalPrice, 10)
    } else {
      originalPrice = productOriginalPrice
    }

    if (price === originalPrice) {
      return 0
    }

    return Math.round(((originalPrice - price) / originalPrice) * 100)
  }
